/** biome-ignore-all lint/style/useNamingConvention: external data */
import type { PageAdConfig } from '@/app_lib/types/Ad';
import type { ArcSpanPageConfig } from '@/app_lib/types/ArcSpan';
import type { GtmPage } from '@/app_lib/types/Gtm';
import type { PianoPageConfig } from '@/app_lib/types/Piano';
import { PageType } from '@/app_lib/types/Post';

// Use this for pages on which we do not want Piano experiences to run
export const defaultPianoPageConfig: PianoPageConfig = {
  contentSection: '',
  franchiseWall: false,
  pageType: PageType.NoType,
  publishDate: '',
  tags: [],
};

export const defaultArcSpanPageConfig: ArcSpanPageConfig = {
  classifications_watson: {
    categories: '',
    concepts: '',
    keywords: '',
  },
  contentPublishDate: null,
  contentSection: '',
  contentTags: [],
  dayOfWeek: '',
  LoginStatus: false,
  pageType: '',
  title: '',
};

export const defaultAdsPageConfig: PageAdConfig = {
  ch: '',
  cid: '',
  ctype: '',
  defaultPath: '',
  invertChAndCtypeInPath: false,
  premiumCategory: '',
  slots: [],
  tags: [],
  topics: [],
};

export const defaultGtmPage: GtmPage = {
  authorNames: [],
  authorUrl: '',
  databaseId: 0,
  dateGmt: '',
  featuredMediaType: '',
  listTitle: '',
  pageType: PageType.NoType,
  pageTypeCG: '',
  personName: '',
  platformCD: '',
  premiumCategory: {
    name: '',
  },
  primarySection: {
    link: '',
    name: '',
    uri: '',
  },
  sectionNames: [],
  tagNames: [],
  title: '',
  year: '',
};
